<template>
	<div id="datepicker" :data-selected-day="getSelectedDate()"></div>
</template>

<script>
	import moment from 'moment';
	
	export default {
		props: ['type'],
		
		data() {
			return {
				datepicker: null,
				eventDates: [],
				initialized: false
			}
		},
		
		mounted() {
			var _this = this;
			
			this.datepicker = $('#datepicker').datepicker({
				onRenderCell (date, cellType) {
					var currentDate = date.getDate();

					if (cellType === 'day' && _this.eventDates.indexOf(currentDate) !== -1) {
						return {
							html: '<div class="dp-day">' + currentDate + '<span class="dp-note"></span></div>'
						}
					}
				},
				onChangeView (view) {
					if (view === 'days') {
						_this.changeData();
					}
				},
				onChangeMonth (month, year) {
					_this.changeData();
				},
				onSelect (formattedDate, date, inst) {
					if (_this.initialized) {
						if (!date) {
							date = new Date(Date.parse($('#datepicker').attr('data-selected-day')));
						}

						_this.onSelect(_this.getFormattedDate(date));
					}
					_this.initialized = true;
				},
			}).data('datepicker');

			var selectedDate = $('#datepicker').attr('data-selected-day');
			_this.datepicker.selectDate(new Date(Date.parse(selectedDate)));
			_this.changeData();
		},
		
		methods: {
			changeData() {
				var currentMonth = this.getFormattedDate(this.datepicker.date);
				
				let path  = '/api/calandar?month=' + currentMonth;
					
				if (this.type) {
					path += '&sport=' + this.type;
				}
				
				this.axios.get(path)
					.then(({data}) => {
						this.eventDates = data;
						this.update();
					});
			},
			onSelect(date) {
				this.$emit('dateSelected', date);
			},
			getFormattedDate(date) {
				var day = date.getDate();
				var month = date.getMonth() + 1;
				var year = date.getFullYear();

				if (month < 10) {
					month = '0' + month;
				}
				if (day < 10) {
					day = '0' + day;
				}

				return year + '-' + month + '-' + day;
			},
			update() {
				this.datepicker.update();
			},
			getSelectedDate() {
				var param = $.urlParam('day');
				
				if (! param) {
					param = this.getFormattedDate(new Date());
				}
				
				return param;
			}
		}
	}
</script>

<style scoped>

</style>